import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
import { useCms } from '../lib/cms';

const fallbackLinks=[['Services','/services'],['Industries','/#industries'],['Work','/work'],['Insights','/insights'],['Company','/careers']];

export function Header(){
 const [open,setOpen]=useState(false);
 const {siteContent}=useCms();
 const links=(siteContent?.navigation?.links?.length?siteContent.navigation.links.map((x:any)=>[x.label,x.href]):fallbackLinks) as string[][];
 const primary=siteContent?.global?.primaryCta||'Start a project';

 useEffect(()=>{
   const close=()=>setOpen(false);
   window.addEventListener('resize',close);
   return()=>window.removeEventListener('resize',close);
 },[]);

 const close=()=>setOpen(false);

 return <header className="site-header">
   <Logo/>
   <nav className="desktop-nav" aria-label="Primary navigation">
     {links.map(([label,href])=><a key={`${label}-${href}`} href={href}>{label}</a>)}
   </nav>
   <a className="nav-cta desktop-cta" href="/book-call"><span>{primary}</span><b>↗</b></a>

   <button className="menu-button" aria-label={open?'Close navigation':'Open navigation'} aria-expanded={open} aria-controls="mobile-navigation" onClick={()=>setOpen(v=>!v)}>{open?<X/>:<Menu/>}</button>

   <AnimatePresence>
    {open&&<motion.nav id="mobile-navigation" className="mobile-menu" aria-label="Mobile navigation" initial={{opacity:0,y:-12}} animate={{opacity:1,y:0}} exit={{opacity:0,y:-12}} transition={{duration:.22,ease:[.2,.8,.2,1]}}>
      {links.map(([label,href],i)=><motion.a key={`${label}-${href}`} href={href} onClick={close} initial={{opacity:0,x:-12}} animate={{opacity:1,x:0}} transition={{delay:i*.035}}>{label}</motion.a>)}
      <a className="nav-cta" href="/book-call" onClick={close}>{primary} <b>↗</b></a>
    </motion.nav>}
   </AnimatePresence>
 </header>
}
